export default "__VITE_ASSET__KrOX4KpZ__"